/**
 *
 */
export const internalsName = "gr-internals";

export const internalsField = Symbol(internalsName);

/**
 *
 *
 *
 *
 *
 */
export const raise = (message: string | Error): never => {
  throw message instanceof Error ? message : new Error(message);
};
